import { render, staticRenderFns } from "./ImportantNotices.vue?vue&type=template&id=2b409174&"
import script from "./ImportantNotices.vue?vue&type=script&lang=ts&"
export * from "./ImportantNotices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports